var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-overlay bg-white",class:{ active: _vm.$root.navigationIsVisble }},[_c('div',{staticClass:"navigation-overlay-inner flex-1 lg:flex flex-col justify-center"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }